import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MaterialDto } from '../../dtos';
import { ApiError, LoadingIndicator, useFailedUpdateSnackbar, useSuccessfulUpdateSnackbar } from '../../Components/CoreLib/library';
import { useGetMaterialByIdQuery, useUpdateMaterialMutation } from '../../store/generated/generatedApi';
import { MaterialForm } from '../../Components/Forms/MaterialForm';

export const EditMaterialView: FC = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { data, isLoading, error, refetch } = useGetMaterialByIdQuery({ id: id! });
    const [updateMaterial, { isSuccess, isError, reset }] = useUpdateMaterialMutation();

    useSuccessfulUpdateSnackbar('Material', isSuccess, reset);
    useFailedUpdateSnackbar('material', isError, reset);

    const handleSave = (values: MaterialDto) => {
        updateMaterial(values);
    };

    const handleCancel = () => {
        navigate('/dataManagement/materials');
    };

    if (isLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <MaterialForm save={handleSave} cancel={handleCancel} initValues={data} />;
};
